import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { LoadingIcon } from '../../../../supplementary_components/loading_icon';
import { API_ROOT, sendRequest } from '../../../../supplementary_components/requests';
import { InstallmentBalanceContainer } from './installmentBalanceSection';
import { ThreeDotsButton } from '../../reusableItems/buttons';
import { addPopup, addNotification} from '../../../../supplementary_components/store';
import { ConfirmationDialogue } from '../../../forms/ConfirmationDialogue';
import { checkForEmptyField } from "../../../forms/Form";
import { getDropBoxFiles } from '../../../forms/input_fields/inputFieldDelegate';
import { priceTypingProcess, priceOnFinish } from '../../../../supplementary_components/priceInputDelegate';
import { CustomAddForm } from '../../../forms/CustomAddForm';
import { dateFormatter } from '../../../../supplementary_components/supplementaryMethods';
import cloneDeep from 'lodash/cloneDeep';
import { IoDocument } from "react-icons/io5";

const MessageContainer = styled.div`
    width:100%;
    text-align:center;
    padding: 2rem;
    font-size: 1.5rem;
    font-weight: 600;
    color:var(--lighter-gray);
`

export function capitalizeFirstLetter(str) {
    if (str.length === 0) return str; // Check for empty string
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/** Normalize payout `attachemnt` (legacy object or JSON array) to `{fileName, filePath}[]`. */
export function normalizePayoutAttachments(attachemnt) {
    if (!attachemnt) return [];
    let parsed = attachemnt;
    if (typeof attachemnt === 'string') {
        try {
            parsed = JSON.parse(attachemnt);
        } catch (e) {
            return [];
        }
    }
    if (Array.isArray(parsed)) {
        return parsed.filter((entry) => entry && entry.filePath);
    }
    if (parsed && typeof parsed === 'object' && parsed.filePath) {
        return [parsed];
    }
    return [];
}
export function localDateToUSFormat(localDate, monthAndDateOnly){
    if (localDate == null) return '';
    if (typeof localDate === 'object') {
        const y = localDate.year ?? localDate.yearValue;
        const m = localDate.month ?? localDate.monthValue;
        const d = localDate.day ?? localDate.dayOfMonth;
        if (y != null && m != null && d != null) {
            const mm = String(m).padStart(2, '0');
            const dd = String(d).padStart(2, '0');
            const yy = String(y).slice(-2);
            return monthAndDateOnly ? `${mm}/${dd}` : `${mm}/${dd}/${yy}`;
        }
        return '';
    }
    const str = String(localDate).trim();
    if (!str) return '';
    const date = str.split('-');
    if (date.length < 3) return '';
    if (monthAndDateOnly) {
        return `${date[1]}/${date[2]}`;
    }
    return `${date[1]}/${date[2]}/${date[0].slice(-2)}`;
}
export const PayoutAdjustments = ({companyId, driverId, newlyAddedAdjustment}) =>{
    const [adjustmentsArray, setAdjustmentsArray] = useState(null);
    useEffect(() => {
        if(adjustmentsArray === null){
            const controller = new AbortController();
            const signal = controller.signal;
            setAdjustmentsArray(undefined);
            sendRequest('GET', API_ROOT+`driverPayoutAdjustments/byDriverId?companyId=${companyId}&driverId=${driverId}`, signal, setAdjustmentsArray, ()=>{
                setAdjustmentsArray(undefined);
            }, null);
            return () => {
                controller.abort();
            };
        }else if (newlyAddedAdjustment){
            setAdjustmentsArray(prev => [...prev, newlyAddedAdjustment]);
        }
    // eslint-disable-next-line
    }, [driverId, newlyAddedAdjustment]);
    
    if(adjustmentsArray === null)return <LoadingIcon state={true} height="5rem" />
    if(adjustmentsArray === undefined)return <MessageContainer>Something Went Wrong</MessageContainer>
    if(adjustmentsArray.length=== 0)return <MessageContainer>No Adjustments Found</MessageContainer>
    return <InstallmentBalanceContainer>
        {adjustmentsArray.map((adjustment, index ) => {
            let withLabel = true;
            if (index > 0)withLabel = false;
            const date = adjustment.date.split('-');
            const attachments = normalizePayoutAttachments(adjustment.attachemnt);
            return  <div key={index} style={{gridTemplateColumns:`30% 1.3fr 1fr 0.6fr 1.1fr 3rem`}}>
                <div>
                    {withLabel?<div className='firstLbl'>Description</div>:null}
                    <div className={`val` }>
                        {adjustment.description}{' '}
                        {attachments.map((attachment, attachmentIndex) => (
                            <IoDocument
                                key={`${attachment.filePath}-${attachmentIndex}`}
                                className="attachment"
                                title={attachment.fileName || 'Attachment'}
                                onClick={(e)=>{
                                    showDriverPayoutAdjustmentsAttachment(attachment.filePath, e.target.parentElement);
                                }}
                            />
                        ))}
                    </div>
                </div>
                <div>
                    {withLabel?<div className='firstLbl'>Type</div>:null}
                    <div className={`val  ${adjustment.type === "charge" ? 'charge' : 'approved'}`}>
                        {capitalizeFirstLetter(adjustment.type)}
                    </div>
                </div>
                <div>
                    {withLabel?<div className='firstLbl'>Date</div>:null}
                    <div className='val'>
                        {`${date[1]}/${date[2]}/${date[0].slice(2)}`}
                    </div>
                </div>
                <div>
                    {withLabel?<div className='firstLbl'>Amount</div>:null}
                    <div className={`val`}>
                        ${(adjustment.amount) }
                    </div>
                    
                </div>
                <div>
                    {withLabel?<div className='firstLbl alignRight'>Status</div>:null}
                    <div className={`val alignRight ${adjustment.status === "inReview" ? "pending" : adjustment.status}`} >
                        {adjustment.status === "inReview" ? "In Review" : capitalizeFirstLetter(adjustment.status)}
                    </div>
                    
                </div>
                <div>
                    {withLabel?<div className='firstLbl'><br /></div>:null}
                    <div className={`val`} >
                        <ThreeDotsButton disabled={adjustment.status !== "pending" && adjustment.status !== "inReview"} onRemove={
                            ()=>{
                                addPopup({
                                    content:ConfirmationDialogue, 
                                    popupData: {
                                        action:(postResultAction)=>{
                                            sendRequest("PATCH", API_ROOT+"driverPayoutAdjustments/remove?adjustmentId="+adjustment.id, null, ()=>{
                                                //success
                                                setAdjustmentsArray(prev =>
                                                    prev.filter(item => item.id !== adjustment.id)
                                                );
                                                postResultAction(true);
                                            }, ()=>{
                                                //error
                                                postResultAction(false);
                                            }, null);
                                        },
                                        name:"Confirm",
                                        formTitle:"Remove Payout Adjustment",
                                        submitTitle:"Remove",
                                        method:"PATCH",
                                        message:"Are you sure you want to remove this adjustment?"
                                    }, 
                                    postSuccessAction: ()=>{
                                    }, 
                                    EZCloseAllowed:true
                                })
                            }
                        } onEdit={()=>{
                            addEditAdjustment(null, setAdjustmentsArray, adjustment, companyId, driverId)
                        }} />
                    </div>
                    
                </div>
            </div>
        })}

    </InstallmentBalanceContainer>
}
export function addAndRemoveLoadingIcon(tag, remove, spinnerCustomWidth, customColor){
    if(remove){
        tag.parentElement.querySelector(".spinner")?.remove();
    }else{
        const spinner = document.createElement('span');
        spinner.className = 'spinner';
        spinner.setAttribute('role', 'status');
        spinner.setAttribute('aria-label', 'Loading'); 
        if(customColor){
            spinner.style.borderColor = customColor;
            spinner.style.borderRightColor = 'transparent';
        }
        
        spinner.style.borderWidth = spinnerCustomWidth || "0.15rem";
        tag.parentElement.insertBefore(spinner, null);
    }
}
export function swapSVGWhileProcessing(action, svgTag, data, metaInfo, spinnerCustomWidth, customColor){
    const spinner = document.createElement('span');
    spinner.className = 'spinner';
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-label', 'Loading'); 
    if(customColor){
        spinner.style.borderColor = customColor;
        spinner.style.borderRightColor = 'transparent';
    }
    if(spinnerCustomWidth){
        spinner.style.borderWidth = spinnerCustomWidth;
    }
    svgTag.replaceWith(spinner);
    Promise.resolve(action(data, metaInfo)).finally(() => {
        spinner.replaceWith(svgTag);
    });
}
export function showDriverPayoutAdjustmentsAttachment(filePath, svgRef){
    const spinner = document.createElement('span');
    spinner.className = 'spinner';
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-label', 'Loading'); 
    svgRef.replaceWith(spinner);
    const body = new FormData();
    body.append("filePath", filePath); 
    sendRequest('POST', API_ROOT+'driverPayoutAdjustments/getFile',null,(res)=>{
        spinner.replaceWith(svgRef);
        res.blob().then(blob => {
            const url = window.URL.createObjectURL(blob);
            window.open(url);
        });
    }, (e)=>{
        // Error
        spinner.replaceWith(svgRef);
        addNotification({message:`Something went wrong`, type:'alert'});
    }, body, {},(body)=>{return body}, true);
    
}
export function addEditAdjustment(data, setDataMethod, editingAdjustment, companyId, driverId){
    const editMethod = (res) =>{
        setDataMethod(prev =>
            prev.map(item =>
              item.id === res.id ? { ...item, ...res } : item
            )
        );
    }
    const addMethod = (res) => {
        const dataClone = cloneDeep(data);
        dataClone.newAdjustment = res;
        setDataMethod(dataClone);
    }
    addEditAdjustmentMehtod(editingAdjustment, editMethod, addMethod, companyId, driverId);
   
}
export function addEditAdjustmentMehtod(editingAdjustment, editMethod, addMethod, companyId, driverId){
    const existingAttachments = normalizePayoutAttachments(editingAdjustment?.attachemnt);
    const InputFormData = {columns: [
        {
            label: "Adjustment Type",
            name: 'type',
            type: 'select',
            dataset: ["Reimbursement", "Charge", "Bonus"],
            defaultValue : editingAdjustment ? ()=>{
                return capitalizeFirstLetter(editingAdjustment.type)
            }:null,
        },
        {
            label: "Date",
            name: 'date',
            mandatory: true,
            autoComplete:"off",
            calendarPickType: 'singleDate',
            checks : [
                (value) => {
                    const res = dateFormatter(value);
                    if(res.date === null){
                        return 'Invalid Input'
                    }
                    return null;
                }
            ],
            onblur:(val, tar)=>{
                return dateFormatter(val).date || val;
            },
            defaultValue:  editingAdjustment ? ()=>{
                return localDateToUSFormat(editingAdjustment.date);
                // const defaultDate = editingAdjustment.date.split('-');
                // return `${defaultDate[1]}/${defaultDate[2]}/${defaultDate[0].slice(-2)}`
            }:()=>{
                const today = new Date();
                return `${String(today.getMonth() + 1).padStart(2, '0')}/` +
                `${String(today.getDate()).padStart(2, '0')}/` +
                `${String(today.getFullYear()).slice(-2)}`;
            }
        },
        {
            label: "Attachment",
            name: 'attachment',
            type: 'dropBox',
            fileType: "any",
            multiple: true,
            file: null,
            files: existingAttachments,
        },
        {
            label: "Description",
            name: 'description',
            // mandatory: true,
            autoComplete:"off",
            defaultValue : editingAdjustment ? ()=>{
                return editingAdjustment.description
            }:null,
        },
        {
            label: "Amount",
            name: "amount",
            // mandatory: true,
            placeholder:'$0.00',
            autoComplete:"off",
            defaultValue : editingAdjustment ? ()=>{
                return priceOnFinish(`${editingAdjustment.amount}`);
            }:null,
            filters:[
                priceTypingProcess
            ],
            onblur:(val)=>{
                return priceOnFinish(val);
            },
        },
    ]}
    addPopup({
        content:CustomAddForm,
        popupData:{
            action:(event, postResultAction)=>{
                event.preventDefault();
                const target = event.target;
                const date = target['date'].value.split('/');
                if (checkForEmptyField(InputFormData, event)){return;}
                const body = new FormData();

                const newObject = {
                    company:{id:companyId},
                    driver:{id:driverId},
                    type:target['type'].value.toLowerCase(),
                    date:`20${date[2]}-${date[0]}-${date[1]}`,
                    description: target['description'].value === "" ? "No description" : target['description'].value,
                    amount: target['amount'].value === "" ? 0 : parseFloat(target['amount'].value.replace(/[^0-9.]/g,''))
                }
                if(editingAdjustment){
                    newObject.id = editingAdjustment.id
                }

                const dropColumn = InputFormData.columns.find((clmn) => clmn.type === 'dropBox');
                const selected = getDropBoxFiles(dropColumn);
                const newFiles = selected.filter((entry) => typeof File !== 'undefined' && entry instanceof File);
                const keptRemote = selected
                    .filter((entry) => !(typeof File !== 'undefined' && entry instanceof File) && entry?.filePath)
                    .map((entry) => ({
                        fileName: entry.fileName || entry.name || 'attachment',
                        filePath: entry.filePath,
                    }));
                const originalPaths = existingAttachments.map((entry) => entry.filePath).join('|');
                const keptPaths = keptRemote.map((entry) => entry.filePath).join('|');
                const attachmentsChanged =
                    newFiles.length > 0 ||
                    (editingAdjustment ? originalPaths !== keptPaths : keptRemote.length > 0);

                body.append("payOutAdjustment", JSON.stringify(newObject));
                if (attachmentsChanged) {
                    body.append('keptAttachments', JSON.stringify(keptRemote));
                    for (const localFile of newFiles) {
                        body.append('file', localFile);
                        body.append('fileName', localFile.name);
                    }
                }

                sendRequest('POST', API_ROOT+'driverPayoutAdjustments/add',null,(res)=>{
                        if(editingAdjustment){
                            editMethod(res)
                            
                        }else{
                            addMethod(res)
                            
                        }
                        postResultAction(true);
                    }, ()=>{
                        postResultAction(false);
                        addNotification({message:`Something went wrong`, type:'alert'});
                    }, body, {companyId:  companyId},(body)=>{return body}, false);
            },
            name:"Confirm",
            formTitle:`${editingAdjustment ? "Edit" : "Add"} Payout Adjustment`,
            submitTitle:`${editingAdjustment ? "Save" : "Add"}`,
            method:"POST",
            columns: InputFormData['columns']
        }, 
        EZCloseAllowed:true
    });
}